<template>
    <v-form ref="form_4">
        <v-row>
            <v-col lg="3" xl="4" class="px-2">
                <v-text-field
                    v-model="buscaProduto"
                    append-icon="mdi-magnify"
                    class="input-button input-cinza"
                    label="Pesquisar"
                    dense
                    outlined
                    hide-details
                >
                    <template>
                        <v-icon slot="append" color="white">mdi-magnify</v-icon>
                    </template></v-text-field
                >
            </v-col>
            <v-col cols="2" class="px-2">
                <v-text-field
                    v-if="!modoClusterNaCampanha"
                    label="VB"
                    v-model="vb"
                    class="input-cinza py-0"
                    outlined
                    dense
                    v-mask="'####'"
                ></v-text-field>
            </v-col>
            <v-col lg="7" xl="6" class="px-2">
                <v-btn
                    class="new-button"
                    color="primary"
                    @click="carregarVB()"
                    v-if="!modoClusterNaCampanha"
                >
                    <v-icon left>mdi-arrow-down</v-icon> Carregar VB
                </v-btn>
                <v-btn
                    class="ml-4 new-button"
                    color="primary"
                    v-if="!modoClusterNaCampanha"
                    @click="recarregarProduto()"
                >
                    <v-icon left>mdi-autorenew</v-icon> Recarregar Produtos
                </v-btn>
                <v-btn
                    class="ml-4 new-button"
                    color="primary"
                    @click="abrirImportacao()"
                >
                    <v-icon left>mdi-upload</v-icon> Importar Base de Produtos
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" class="py-4">
                <v-text-field
                    label="Categoria"
                    outlined
                    dense
                    v-model="value.categoria_produto"
                    class="input-cinza"
                    readonly
                ></v-text-field>
            </v-col>
            <v-col cols="9" class="px-2" align="end"> </v-col>
        </v-row>
        <v-data-table
            :key="chaveTabelaProdutosCampanha"
            :headers="listaHeaderProdutoDinamica"
            :items="produto"
            :search="buscaProduto"
            item-key="id_produto"
            class="elevation-0 tabela"
            :items-per-page="5"
            :footer-props="{
                'items-per-page-options': [5, 10, 15, 25, 50, 100, -1],
            }"
            :options.sync="pagination"
        >
            <template v-slot:[`item.pdv`]="{ item }">
                <v-checkbox
                    :ripple="false"
                    v-model="item.pdv"
                    @change="onTogglePdv(item, $event)"
                    hide-details
                    class="d-inline-flex mt-0"
                ></v-checkbox>
            </template>
            <template v-slot:[`item.ecommerce`]="{ item }">
                <v-checkbox
                    :ripple="false"
                    v-model="item.ecommerce"
                    hide-details
                    class="d-inline-flex mt-0"
                ></v-checkbox>
            </template>
            <template v-slot:[`item.vb_pdv`]="{ item }">
                <v-text-field
                    v-if="!modoClusterNaCampanha"
                    :ripple="false"
                    dense
                    outlined
                    v-mask="'####'"
                    class="input-cinza"
                    v-model="item.vb_pdv"
                    @change="vbChange(item)"
                    hide-details
                ></v-text-field>
            </template>
            <template v-for="cluster in clustersAtivos" v-slot:[`item.${cluster.nome}`]="{ item }">
                <v-text-field
                    :key="cluster.nome"
                    :ripple="false"
                    dense
                    outlined
                    v-mask="'####'"
                    class="input-cinza"
                    v-model="item[cluster.nome]"
                    hide-details
                ></v-text-field>
            </template>
        </v-data-table>

        <v-row no-gutters class="mb-3 mt-1">
            <v-col cols="12" class="px-2 ml-auto" align="end">
                <v-btn
                    class="ml-2 mb-1 new-button"
                    color="error"
                    @click="limpaProdutos(true)"
                >
                    <v-icon left>mdi-trash-can</v-icon> Limpar Produtos
                </v-btn>

                <v-btn
                    class="ml-2 mb-1 new-button"
                    color="primary"
                    @click="carregarProduto()"
                    v-if="!modoClusterNaCampanha"
                >
                    <v-icon left>mdi-arrow-up</v-icon> Carregar Produtos Salvos
                </v-btn>
                <v-btn
                    class="ml-2 mb-1 new-button"
                    color="primary"
                    @click="salvarProdutoOuCluster()"
                >
                    <v-icon left>mdi-arrow-down</v-icon> Salvar Produtos
                    Selecionados
                </v-btn>
            </v-col>
        </v-row>

        <!-- Alerta de produtos faltando -->
        <v-row
            v-if="
                modoClusterNaCampanha &&
                temProdutosFaltando &&
                produtoSalvo.length > 0
            "
            class="mb-2"
        >
            <v-col cols="12">
                <v-alert type="error" text class="mb-0">
                    <strong>Produtos faltando:</strong>
                    <span
                        v-if="produtosFaltandoEcommerce.length > 0"
                        class="ml-2"
                    >
                        E-commerce
                    </span>
                    <span v-if="produtosFaltandoPDV.length > 0" class="ml-2">
                        PDV ({{ produtosFaltandoPDV.join(', ') }})
                    </span>
                </v-alert>
            </v-col>
        </v-row>

        <v-data-table
            :key="chaveTabelaSalvosCampanha"
            :headers="listaHeaderProdutoSalvoDinamica"
            :items="produtoSalvo"
            item-key="nome"
            class="elevation-0 tabela mt-4"
            hide-default-footer
            disable-sort
        >
            <template v-slot:[`item.pdv`]="{ item }">
                <v-checkbox
                    :ripple="false"
                    v-model="item.pdv"
                    hide-details
                    class="d-inline-flex mt-0"
                    disabled
                ></v-checkbox>
            </template>
            <template v-slot:[`item.ecommerce`]="{ item }">
                <v-checkbox
                    :ripple="false"
                    v-model="item.ecommerce"
                    hide-details
                    class="d-inline-flex mt-0"
                    disabled
                ></v-checkbox>
            </template>
            <template v-slot:[`item.vb_pdv`]="{ item }">
                <v-text-field
                    v-if="!modoClusterNaCampanha"
                    :ripple="false"
                    dense
                    outlined
                    class="input-cinza"
                    v-mask="'####'"
                    v-model="item.vb_pdv"
                    hide-details
                ></v-text-field>
            </template>
            <template v-for="cluster in clustersAtivos" v-slot:[`item.${cluster.nome}`]="{ item }">
                <v-text-field
                    :key="'salvo-' + cluster.nome"
                    :ripple="false"
                    dense
                    outlined
                    class="input-cinza"
                    v-mask="'####'"
                    v-model="item[cluster.nome]"
                    hide-details
                ></v-text-field>
            </template>
        </v-data-table>

        <v-overlay :value="carregando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <importar-produtos
            ref="importarProdutos"
            @importar="importar"
            @exportarModelo="exportarModelo"
        ></importar-produtos>
        <div v-if="dialogoCamposFaltando" class="dialogo-erro" width="700px">
            <v-card class="br-15">
                <v-toolbar
                    elevation="0"
                    dark
                    class="error white--text fix-flex"
                >
                    <v-toolbar-title>
                        Por favor retorne as etapas anteriores e preencha os
                        seguintes campos:</v-toolbar-title
                    >
                </v-toolbar>
                <v-card-text class="pa-5">
                    <v-list>
                        <v-list-item
                            v-for="campo in camposFaltando"
                            :key="campo"
                        >
                            <v-list-item-content>
                                <v-list-item-title>{{
                                    campo
                                }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </div>
        <v-overlay
            :value="semAcesso"
            :absolute="true"
            :opacity="0.1"
            :z-index="3"
        ></v-overlay>
        <v-overlay
            :value="mostraOverlay"
            :absolute="true"
            :opacity="0.6"
            :z-index="3"
        ></v-overlay>

        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 6"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">
                Fechar
            </v-btn>
        </v-snackbar>
    </v-form>
</template>

<script>
import importarProdutos from './importarProdutos.vue'

const listaHeaderProdutoSalvo = [
    {
        text: 'PDV',
        value: 'pdv',
        align: 'center',
        class: 'th-separador text-xs-center',
        width: '60px',
    },
    {
        text: 'E-com.',
        value: 'ecommerce',
        align: 'center',
        class: 'th-separador text-xs-center',
        width: '60px',
    },
    {
        text: 'Código',
        value: 'codigo',
        align: 'center',
        class: 'th-separador',
    },
    {
        text: 'Marca',
        value: 'marca',
        align: 'center',
        class: 'th-separador',
    },
    {
        text: 'Produtos Salvos',
        value: 'nome',
        align: 'center',
        class: 'th-separador',
    },
    {
        text: 'Quantidade de VB',
        value: 'vb_pdv',
        align: 'center',
    },
]

/** Mesmo critério de [Formulario.vue carregaProduto](Formulario.vue) */
const ID_ESPACOS_PDV_PRODUTOS_POR_CLUSTER = [
    4491, 633, 669, 645, 681, 657, 687,
]

export default {
    inject: ['listaCampos'],
    components: {
        importarProdutos,
    },
    props: ['value'],
    async created() {
        var lista = await this.listaCampos
        this.$set(this.lista, 'categoria_produto', lista.categoria_produto)
        this.$set(this.lista, 'cluster', lista.cluster)
    },
    data() {
        return {
            acordo: {},
            produto: [],
            produtoServidor: [],
            // produtoSelecionado: [],
            produtoSalvo: [],
            somaProdutoSalvo: [],
            dialogoCamposFaltando: false,
            buscaProduto: '',
            vb: '',
            clusters: [
                'POPULAR',
                'SUPER POPULAR',
                'HIBRIDA',
                'NOBRE',
                'SUPER NOBRE',
                'AMPLA',
            ],
            listaHeaderProduto: [
                {
                    text: 'PDV',
                    value: 'pdv',
                    align: 'center',
                    class: 'th-separador text-xs-center',
                    width: '60px',
                },
                {
                    text: 'E-com.',
                    value: 'ecommerce',
                    align: 'center',
                    class: 'th-separador text-xs-center',
                    width: '60px',
                },
                {
                    text: 'Código',
                    value: 'codigo',
                    align: 'center',
                    class: 'th-separador',
                },
                {
                    text: 'Marca',
                    value: 'marca',
                    align: 'center',
                    class: 'th-separador',
                },
                {
                    text: 'Descrição',
                    value: 'nome',
                    align: 'center',
                    class: 'th-separador',
                },
                {
                    text: 'Ativo/Inativo',
                    value: 'ativo_inativo',
                    align: 'center',
                    class: 'th-separador',
                },
                {
                    text: 'Curva do produto',
                    value: 'curva',
                    align: 'center',
                    class: 'th-separador',
                },
                {
                    text: 'VB',
                    value: 'vb_pdv',
                    align: 'center',
                    width: '120px',
                },
            ],
            listaHeaderProdutoSalvo: listaHeaderProdutoSalvo,
            lista: {},
            carregando: false,
            pagination: {},
            semAcesso: false,
            alerta: false,
            alertaTexto: '',
            alertaColor: 'info',
            alertaTimeout: 5000,
        }
    },
    computed: {
        /**
         * Não depender só de value.produtos_por_cluster (só é setado em carregaProduto).
         * Usa o mesmo critério do Formulario para a UI aparecer corretamente ao abrir a etapa.
         */
        modoClusterNaCampanha() {
            const id = this.value.id_espaco_pdv
            const idNum = Number(id)
            const porEspaco =
                id !== null &&
                id !== undefined &&
                id !== '' &&
                !Number.isNaN(idNum) &&
                ID_ESPACOS_PDV_PRODUTOS_POR_CLUSTER.includes(idNum)
            if (porEspaco) {
                return true
            }
            return this.value.produtos_por_cluster === true
        },
        chaveTabelaProdutosCampanha() {
            const prefixo = this.modoClusterNaCampanha ? 'cl' : 'vb'
            const colunas = this.clustersAtivos.map((c) => c.nome).join('|')
            return prefixo + ':' + colunas
        },
        chaveTabelaSalvosCampanha() {
            const prefixo = this.modoClusterNaCampanha ? 's-cl' : 's-vb'
            const colunas = this.clustersAtivos.map((c) => c.nome).join('|')
            return prefixo + ':' + colunas
        },
        camposFaltando() {
            const campos = []
            if (!this.value.id_fornecedor) {
                campos.push('Fornecedor')
            }
            return campos
        },
        mostraOverlay() {
            if (this.camposFaltando.length > 0) {
                return true
            }
            return false
        },
        produtoSelecionado() {
            return this.produto.filter((item) => item.ecommerce || item.pdv)
        },
        /**
         * Monta a lista de clusters para colunas VB e payload.
         * Não priorizar só value.clustersNomes: pode vir vazio ou desatualizado antes/durante a etapa.
         * Critério alinhado a Formulario.carregaProduto + fallbacks quando ids de filial não batem com lista.cluster.
         */
        clustersNomesOrigem() {
            if (!this.modoClusterNaCampanha) {
                return []
            }

            const listaCluster = this.lista.cluster || []
            const ids = this.value.clustersNoAcordo || []
            const nomesPersistidos = this.value.clustersNomes

            const montarPorIdsFiliais = () => {
                if (ids.length === 0) {
                    return null
                }
                const incluiClusterTodos = ids.some(
                    (x) => x == 7 || x === '7'
                )
                if (incluiClusterTodos) {
                    if (listaCluster.length > 0) {
                        return listaCluster.map((item) => ({
                            id: item.value,
                            nome: item.text,
                        }))
                    }
                    return this.clusters.map((nome) => ({ nome }))
                }
                if (listaCluster.length === 0) {
                    return null
                }
                const resolved = []
                for (let i = 0; i < ids.length; i++) {
                    const idCluster = ids[i]
                    for (let j = 0; j < listaCluster.length; j++) {
                        const itemLista = listaCluster[j]
                        if (idCluster == itemLista.value) {
                            resolved.push({
                                id: idCluster,
                                nome: itemLista.text,
                            })
                        }
                    }
                }
                if (resolved.length > 0) {
                    return resolved
                }
                return null
            }

            const porFiliais = montarPorIdsFiliais()
            if (porFiliais && porFiliais.length > 0) {
                return porFiliais
            }

            if (nomesPersistidos && nomesPersistidos.length > 0) {
                return nomesPersistidos
            }

            if (listaCluster.length > 0 && ids.length > 0) {
                return listaCluster.map((item) => ({
                    id: item.value,
                    nome: item.text,
                }))
            }

            if (ids.length === 0) {
                return []
            }

            return this.clusters.map((nome) => ({ nome }))
        },
        clustersAtivos() {
            const origem = this.clustersNomesOrigem
            if (!origem || origem.length === 0) {
                return []
            }
            return origem.map((cluster) => {
                if (typeof cluster === 'string') {
                    return { nome: cluster }
                }
                return cluster
            })
        },
        listaHeaderProdutoDinamica() {
            if (!this.modoClusterNaCampanha) {
                return this.listaHeaderProduto
            }
            const semColunaVbPdv = this.listaHeaderProduto.filter(
                (header) => header.value !== 'vb_pdv'
            )
            const headersClusters = this.clustersAtivos.map((cluster) => ({
                text: cluster.nome,
                value: cluster.nome,
                align: 'center',
                width: '120px',
            }))
            return [...semColunaVbPdv, ...headersClusters]
        },
        listaHeaderProdutoSalvoDinamica() {
            if (!this.modoClusterNaCampanha) {
                return this.listaHeaderProdutoSalvo
            }
            const semColunaVbPdv = this.listaHeaderProdutoSalvo.filter(
                (header) => header.value !== 'vb_pdv'
            )
            const headersClusters = this.clustersAtivos.map((cluster) => ({
                text: cluster.nome,
                value: cluster.nome,
                align: 'center',
            }))
            return [...semColunaVbPdv, ...headersClusters]
        },
        contemEspacoPDV() {
            return this.value.id_espaco_pdv && this.value.id_espaco_pdv > 0
        },
        contemEspacoEcommerce() {
            return (
                this.value.id_espaco_ecommerce &&
                this.value.id_espaco_ecommerce > 0
            )
        },
        // Computed properties para validação e alertas
        produtosFaltandoEcommerce() {
            if (!this.contemEspacoEcommerce) return []
            const temEcommerce = this.produtoSalvo.some(
                (p) => p.ecommerce === true
            )
            if (!temEcommerce) {
                return ['E-commerce']
            }
            return []
        },
        produtosFaltandoPDV() {
            if (!this.contemEspacoPDV) return []
            const clustersSemProdutos = []

            for (const cluster of this.clustersAtivos) {
                const temProdutoNoCluster = this.produtoSalvo.some(
                    (p) => p[cluster.nome] !== undefined && p[cluster.nome] >= 0
                )

                if (!temProdutoNoCluster) {
                    clustersSemProdutos.push(cluster.nome)
                }
            }

            return clustersSemProdutos
        },
        temProdutosFaltando() {
            return (
                this.produtosFaltandoEcommerce.length > 0 ||
                this.produtosFaltandoPDV.length > 0
            )
        },
    },
    watch: {
        modoClusterNaCampanha: {
            handler(novo) {
                if (this.value.produtos_por_cluster !== novo) {
                    this.$set(this.value, 'produtos_por_cluster', novo)
                }
            },
            immediate: true,
        },
        produto: {
            handler(newVal, oldVal) {
                // Deep watching para detectar mudanças nas propriedades ecommerce e pdv
                this.$forceUpdate()
            },
            deep: true,
        },
    },
    methods: {
        setAcordo(acordo) {
            //this.acordo = { ...acordo };
        },
        setSemAcesso(semAcesso) {
            this.semAcesso = semAcesso
        },
        async vbChange(value) {
            if (value.vb_pdv !== '') {
                value.pdv = true
            } else {
                value.pdv = false
            }
            await this.$forceUpdate()
        },
        onTogglePdv(item, marcado) {
            const emEdicaoOuRenovacao = this.value.fnEditar || this.value.fnReplicar
            if (emEdicaoOuRenovacao && marcado === false) {
                this.alerta = true
                this.alertaColor = 'info'
                this.alertaTexto =
                    'Favor retirar a quantidade do VB para que o produto não seja mais considerado no acordo.'
            }
        },
        async buscaProdutos() {
            var clusterInAcordo = []
            if (this.camposFaltando.length > 0) {
                this.dialogoCamposFaltando = true
                return
            }
            if (!this.value.fnEditar && this.produto.length > 0) {
                this.dialogoCamposFaltando = false
                return
            }
            if (this.produtoServidor.length > 0) {
                return
            }
            // this.produtoSelecionado = [];

            this.dialogoCamposFaltando = false
            this.carregando = true
            this.carregando = true

            var data = {}

            data.id_fornecedor = this.value.id_fornecedor

            data.produtos_por_cluster = this.modoClusterNaCampanha

            data.clustersNomes = this.clustersNomesOrigem

            if (this.value.fnEditar || this.value.fnReplicar) {
                data.id_acordo = this.value.idAcordos[0]
            }

            var response = await this.$http().post(
                '/acordoCampanhas/produtos',
                {
                    data: data,
                }
            )

            this.produto = JSON.parse(JSON.stringify(response.data))

            this.produtoServidor = JSON.parse(JSON.stringify(response.data))

            this.pagination.page = 1

            if (this.value.fnEditar || this.value.fnReplicar) {
                if (this.modoClusterNaCampanha) {
                    const idsAcordo = this.value.clustersNoAcordo || []
                    const incluiClusterTodos = idsAcordo.some(
                        (id) => id == 7 || id === '7'
                    )
                    const listaClusterLocal = this.lista.cluster || []
                    clusterInAcordo = listaClusterLocal.filter((item) => {
                        if (incluiClusterTodos) {
                            return true
                        }
                        for (let i = 0; i < idsAcordo.length; i++) {
                            if (idsAcordo[i] == item.value) {
                                return true
                            }
                        }
                        return false
                    })
                }
                if (this.modoClusterNaCampanha) {
                    var produtos = JSON.parse(
                        JSON.stringify(this.produtoServidor)
                    )
                    var produtosAjustados = []
                    for (const produto of produtos) {
                        let encontrado = false
                        if (produto.vb_ecommerce == 1) {
                            produto.ecommerce = true
                        }
                        if (produto.vb_pdv === 0 || produto.vb_pdv > 0) {
                            produto.pdv = true
                            const atualCluster = clusterInAcordo.filter(
                                (item) => item.value == produto.id_cluster
                            )[0]
                            if (atualCluster) {
                                produto[atualCluster.text] = produto.vb_pdv
                            }
                        }
                        for (var ajustado of produtosAjustados) {
                            if (ajustado.id_produto == produto.id_produto) {
                                // ajustado.ecommerce = ajustado.ecommerce ? ajustado.ecommerce : produto.ecommerce
                                // ajustado.pdv = ajustado.pdv ? ajustado.pdv : produto.pdv
                                // ajustado = {...ajustado,...produto}
                                for (var propriedade in produto) {
                                    ajustado[propriedade] = ajustado[
                                        propriedade
                                    ]
                                        ? ajustado[propriedade]
                                        : produto[propriedade]
                                }
                                encontrado = true
                            }
                        }
                        if (!encontrado) {
                            produtosAjustados.push(produto)
                        }
                    }
                    this.produto = produtosAjustados
                    // var produtosEscolhidos = []
                    // for (const produto of this.produto) {
                    //     let encontrado = false;
                    //     if(produto.vb_ecommerce == 1){
                    //         produto.ecommerce = true
                    //         produtosEscolhidos.push(produto)
                    //     }
                    //     if (produto.vb_pdv === 0 || produto.vb_pdv > 0) {
                    //         const atualCluster = clusterInAcordo.filter(item => item.value == produto.id_cluster)[0]
                    //         if (atualCluster) {
                    //             for (var itemEmProduto of produtosEscolhidos) {
                    //                 if (itemEmProduto.id_produto == produto.id_produto) {
                    //                     // itemEmProduto = {...produto,...itemEmProduto}

                    //                     itemEmProduto[atualCluster.text] = produto.vb_pdv

                    //                     encontrado = true;
                    //                 }
                    //             }
                    //         }
                    //         if (!encontrado) {
                    //             // produto[atualCluster.text] = produto.vb_pdv
                    //             produto.pdv = true
                    //             produtosEscolhidos.push(produto)
                    //         }
                    //     }

                    // }
                    // this.produtoSelecionado = produtosAjustados
                } else {
                    for (const p of this.produto) {
                        if (p.vb_pdv != null || p.vb_ecommerce) {
                            if (p.vb !== null) {
                                p.pdv = true
                            }
                            if (p.vb_ecommerce == 1) {
                                p.ecommerce = true
                            }
                            this.produtoSelecionado.push(p)
                        }
                    }
                }

                if (this.modoClusterNaCampanha) {
                    this.salvarProdutoCluster()
                } else {
                    this.salvarProduto(false)
                }
            }

            this.carregando = false
        },
        carregarVB() {
            for (const d of this.produto) {
                d.vb = this.vb
            }
        },
        salvarProdutoOuCluster() {
            if (this.modoClusterNaCampanha) {
                this.salvarProdutoCluster()
            } else {
                this.salvarProduto()
            }
        },
        salvarProduto(alert = true) {
            this.produtoSalvo = []

            const vbZerado = this.produto.filter(
                (p) => p.pdv == true && p.vb_pdv == 0
            )

            var vb = 0
            var fnVB = 0
            for (const produto of this.produto) {
                if (produto.pdv == true || produto.ecommerce == true) {
                    this.produtoSalvo.push(produto)
                }
            }

            var soma = [
                {
                    produto: this.produtoSalvo.length,
                    vb: vb,
                },
            ]

            console.log('this.produtoSalvo', this.produtoSalvo)

            this.somaProdutoSalvo = soma
                        // atualiza o campo categoria_produto
            // concatena todos os nomes de grupos dos produtos salvos e cria uma string separada por hifen (-) em ordem alfabética.
            const grupos = [...new Set(this.produtoSalvo.map(p =>  p.grupo == 'MEDICAMENTO' ? 'RX' : p.grupo))].sort().join('-');
            this.value.categoria_produto = grupos;
        },
        carregarProduto() {
            this.produto = []
            // this.produtoSelecionado = [];

            for (const p of this.produtoSalvo) {
                this.produto.push(p)

                if (+p.vb > 0) {
                    this.produtoSelecionado.push(p)
                }
            }

            this.pagination.page = 1
        },
        recarregarProduto() {
            this.produto = []

            for (const d of this.produtoServidor) {
                this.produto.push({ ...d })
            }

            this.pagination.page = 1
        },
        limpaProdutosSelecionados() {
            this.produto.forEach((produto) => {
                produto.pdv = false
                produto.ecommerce = false
                produto.vb = null
            })
        },
        limpaProdutos(fnServidor = false) {
            this.produto = []
            this.produtoServidor = []
            // this.produtoSelecionado = [];
            this.limpaProdutosSelecionados()
            this.produtoSalvo = []
            this.somaProdutoSalvo = []
            this.vb = ''
            if (fnServidor) {
                this.buscaProdutos()
            }

        },
        async abrirImportacao() {
            this.$refs.importarProdutos.abrir(
                this.produtoServidor,
                this.modoClusterNaCampanha
            )
        },
        async importar() {
            var dadosTemp = this.$refs.importarProdutos.dadosTemp
            this.limpaProdutosSelecionados()

            for (const produtoImportado of dadosTemp) {
                let keys = _.keys(produtoImportado)
                const produtoIndex = this.produto.findIndex(
                    (p) => p.id_produto == produtoImportado.id_produto
                )
                // const produto = this.produto.find(p => p.id_produto == produtoImportado.id_produto);
                if (produtoIndex > -1) {
                    if (this.modoClusterNaCampanha) {
                        // let selecionado = false
                        for (let c = 0; c < keys.length; c++) {
                            if (
                                this.clusters.includes(keys[c]) &&
                                (produtoImportado[keys[c]] === 0 ||
                                    produtoImportado[keys[c]] > 0)
                            ) {
                                this.produto[produtoIndex].pdv = true
                                this.produto[produtoIndex][keys[c]] =
                                    produtoImportado[keys[c]]
                                // selecionado = true/
                            }
                        }
                    } else {
                        if (produtoImportado.vb_pdv > 0) {
                            this.produto[produtoIndex].pdv = true
                            this.produto[produtoIndex].vb =
                                produtoImportado.vb_pdv
                        }
                    }
                    if (produtoImportado.vb_ecommerce > 0) {
                        this.produto[produtoIndex].ecommerce = true
                    }
                }
            }

            this.salvarProdutoOuCluster()
        },
        async exportarModelo() {
            this.$refs.importarProdutos.carregando = true

            var data = {}

            data.id_fornecedor = this.value.id_fornecedor

            if (this.value.fnEditar || this.value.fnReplicar) {
                data.id_acordo = this.value.idAcordos[0]
            }

            data.produtos_por_cluster = this.modoClusterNaCampanha
            data.clustersNomes = this.clustersNomesOrigem

            var response = await this.$http().post(
                '/acordoCampanhas/modeloProdutos',
                {
                    data: data,
                }
            )

            window.location = this.$http('baseURL') + response.data.url

            this.$refs.importarProdutos.carregando = false
        },
        salvarProdutoCluster() {
            this.produtoSalvo = []

            for (const produto of this.produto) {
                const temVbEmAlgumCluster = this.clustersAtivos.some((cluster) => {
                    const vb = produto[cluster.nome]
                    return vb === 0 || (vb > 0 && !isNaN(vb))
                })

                const temEcommerce = produto.ecommerce === true

                if (temVbEmAlgumCluster || temEcommerce) {
                    this.produtoSalvo.push({ ...produto })
                }
            }

            const grupos = [...new Set(this.produtoSalvo.map((p) => p.grupo == 'MEDICAMENTO' ? 'OTC' : p.grupo))].sort().join('-')
            this.value.categoria_produto = grupos
        },
        validate() {
            if (this.modoClusterNaCampanha) {
                if (this.produtoSalvo.length === 0) {
                    return false
                }
                return !this.temProdutosFaltando
            }

            return this.produtoSelecionado.length > 0
        },
    },
}
</script>